export default __webpack_public_path__ + "static/media/Cream1.9f30e660.png";